const cartTotal = document.getElementById('cartTotal');

export const cartStats = () => {
    if (!sessionStorage.getItem('totalItems')) {
        return cartTotal.innerText = 0;
    }
    cartTotal.innerText = sessionStorage.getItem('totalItems')
}